import { extractErrorMessage, post } from "src/helpers/api_helper"
import { SIGN_IN } from "src/helpers/url_helper"
import { IToken, ResponseRequest } from "./types";
import { setToken } from "src/helpers/auth_helper";

export const signIn = async ({email, password} : {email:string, password: string}): Promise<ResponseRequest<IToken>> => {
    try {
        const response = await post<IToken>(SIGN_IN, {email, password})
        if (response.code === 200) {
            setToken(response.data!)
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}

export const getProfile = async (): Promise<ResponseRequest<any>> => {
    try {
        const response = await post<any>("/get-profile", {});
        if (response.code === 200) {
            return { result: "ok", data: response.data }
        } else {
            return { result: "error", message: response.message }
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}
    